// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"413":"b0d72ec9","953":"c9983e98","963":"86d5bb65","988":"08be054a"}[chunkId] + ".chunk.js";
};